import React, { useEffect, useState } from "react";
import axios from "axios";
import AppShell from "../components/AppShell";
import ColombianAddressInput from "../components/ColombianAddressInput";

const API_BASE = `${process.env.REACT_APP_API_URL || ""}`;

const initialUserForm = {
  username: "",
  email: "",
  first_name: "",
  last_name: "",
  password: "",
  role: "ARRENDADOR",
};

const initialEmpresaForm = {
  TENit: "",
  TENombre: "",
  TEDireccion: "",
  TECiudad: "",
  TECelular: "",
  TETelefono: "",
  TEEmail: "",
  TEContacto: "",
  TEDescripcion: "",
};

const initialTipoReporteForm = {
  TRHTipoReporte: "",
  TRDescripcion: "",
  TRPeso: "",
  TRActivo: true,
};

const initialPuntajeColorForm = {
  TPCNivel: "",
  TPCValorInicial: "",
  TPCValorFinal: "",
  TPCColor: "#000000",
  TPCEvaluacion: "",
  TPCComentario: "",
  TPCActivo: true,
};

const initialCiudadForm = {
  TCNombre: "",
  TCDepartamento: "",
  TCPais: "",
};

const initialIpcForm = {
  anio: "",
  porcentaje: "",
  descripcion: "",
  activo: true,
};

const buildAuthConfig = (token) => ({
  headers: {
    Authorization: `Token ${token}`,
    "Content-Type": "application/json",
  },
});

const getErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  if (!data) return fallback;
  if (typeof data === "string") return data;
  if (data.error) return data.error;

  const firstKey = Object.keys(data)[0];
  const firstValue = firstKey ? data[firstKey] : null;

  if (Array.isArray(firstValue) && firstValue.length > 0) {
    return `${firstKey}: ${firstValue[0]}`;
  }

  if (typeof firstValue === "string") {
    return `${firstKey}: ${firstValue}`;
  }

  return fallback;
};

export default function Parametrizacion() {
  const token = localStorage.getItem("token");
  const currentUsername = localStorage.getItem("user");

  const [loading, setLoading] = useState(true);
  const [feedback, setFeedback] = useState("");
  const [feedbackType, setFeedbackType] = useState("success");

  const [users, setUsers] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [ciudades, setCiudades] = useState([]);

  const [activeView, setActiveView] = useState("usuarios");
  const [searchUsuario, setSearchUsuario] = useState("");
  const [searchEmpresa, setSearchEmpresa] = useState("");
  const [searchCiudad, setSearchCiudad] = useState("");

  const [tiposReporte, setTiposReporte] = useState([]);
  const [puntajesColor, setPuntajesColor] = useState([]);
  const [ipcs, setIpcs] = useState([]);
  const [searchIpc, setSearchIpc] = useState("");

  const [tipoReporteForm, setTipoReporteForm] = useState(initialTipoReporteForm);
  const [puntajeColorForm, setPuntajeColorForm] = useState(initialPuntajeColorForm);
  const [ipcForm, setIpcForm] = useState(initialIpcForm);

  const [editingTipoReporteId, setEditingTipoReporteId] = useState(null);
  const [editingPuntajeColorId, setEditingPuntajeColorId] = useState(null);
  const [editingIpcAnio, setEditingIpcAnio] = useState(null);


  const [userForm, setUserForm] = useState(initialUserForm);
  const [empresaForm, setEmpresaForm] = useState(initialEmpresaForm);
  const [ciudadForm, setCiudadForm] = useState(initialCiudadForm);

  const [editingUserId, setEditingUserId] = useState(null);
  const [editingEmpresaId, setEditingEmpresaId] = useState(null);
  const [editingCiudadId, setEditingCiudadId] = useState(null);
  
  const [isEmpresaAddressValid, setIsEmpresaAddressValid] = useState(false);

  const authConfig = buildAuthConfig(token);

  const showFeedback = (message, type = "success") => {
    setFeedback(message);
    setFeedbackType(type);
  };

  const loadAll = async () => {
    try {
      setLoading(true);
      const [usersRes, empresasRes, ciudadesRes] = await Promise.all([
        axios.get(`${API_BASE}/api/auth/users/`, authConfig),
        axios.get(`${API_BASE}/api/empresas/`, authConfig),
        axios.get(`${API_BASE}/api/ciudades/`, authConfig),
      ]);

      setUsers(usersRes.data || []);
      setEmpresas(empresasRes.data || []);
      setCiudades(ciudadesRes.data || []);

        const tiposRes = await axios.get(`${API_BASE}/api/tablas-maestras/tipo-reporte/`, authConfig);
        const puntajesRes = await axios.get(`${API_BASE}/api/tablas-maestras/puntaje-color/`, authConfig);
        const ipcRes = await axios.get(`${API_BASE}/api/tablas-maestras/ipc/`, authConfig);
        setTiposReporte(tiposRes.data.results || tiposRes.data || []);
        setPuntajesColor(puntajesRes.data.results || puntajesRes.data || []);
        setIpcs(ipcRes.data.results || ipcRes.data || []);

    } catch (error) {
      showFeedback(getErrorMessage(error, "No fue posible cargar la informacion administrativa."), "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const resetUserForm = () => {
    setUserForm(initialUserForm);
    setEditingUserId(null);
  };

  const resetEmpresaForm = () => {
    setEmpresaForm(initialEmpresaForm);
    setEditingEmpresaId(null);
  };

  const resetCiudadForm = () => {
    setCiudadForm(initialCiudadForm);
    setEditingCiudadId(null);
  };

  const submitUser = async (event) => {
    event.preventDefault();

    try {
      const payload = { ...userForm, password: userForm.password.trim() };

      if (!editingUserId && !payload.password) {
        showFeedback("La contrasena es obligatoria al crear un usuario.", "error");
        return;
      }

      const url = editingUserId ? `${API_BASE}/api/auth/users/${editingUserId}/` : `${API_BASE}/api/auth/users/`;
      const method = editingUserId ? "put" : "post";
      await axios[method](url, payload, authConfig);

      await loadAll();
      resetUserForm();
      showFeedback(editingUserId ? "Usuario actualizado correctamente." : "Usuario creado correctamente.");
    } catch (error) {
      showFeedback(getErrorMessage(error, "No fue posible guardar el usuario."), "error");
    }
  };

  const submitEmpresa = async (event) => {
    event.preventDefault();

    if (!isEmpresaAddressValid && empresaForm.TEDireccion) {
      showFeedback("La dirección de la empresa no cumple con el formato estándar.", "error");
      return;
    }

    try {
      const payload = {
        ...empresaForm,
        TEDescripcion: empresaForm.TEDescripcion.trim() || empresaForm.TENombre.trim(),
      };

      try {
        if (empresaForm.TEDireccion) {
          const dirResponse = await axios.post(
            `${API_BASE}/api/direcciones/normalizar/`,
            { direccion: empresaForm.TEDireccion },
            { headers: { "Content-Type": "application/json", Authorization: `Token ${token}` } }
          );
          if (dirResponse.data && dirResponse.data.datos) {
            payload.TEDireccion = dirResponse.data.datos.direccion_normalizada;
            payload.TEDireccion_id = dirResponse.data.datos.id;
          }
        }
      } catch (errDir) {
        console.warn("No se pudo normalizar la dirección de la empresa en AdminPanel.", errDir);
      }

      const url = editingEmpresaId ? `${API_BASE}/api/empresas/${editingEmpresaId}/` : `${API_BASE}/api/empresas/`;
      const method = editingEmpresaId ? "put" : "post";
      await axios[method](url, payload, authConfig);

      await loadAll();
      resetEmpresaForm();
      showFeedback(editingEmpresaId ? "Empresa actualizada correctamente." : "Empresa creada correctamente.");
    } catch (error) {
      showFeedback(getErrorMessage(error, "No fue posible guardar la empresa."), "error");
    }
  };

  const submitCiudad = async (event) => {
    event.preventDefault();

    try {
      const payload = {
        ...ciudadForm,
      };

      const url = editingCiudadId ? `${API_BASE}/api/ciudades/${editingCiudadId}/` : `${API_BASE}/api/ciudades/`;
      const method = editingCiudadId ? "put" : "post";
      await axios[method](url, payload, authConfig);

      await loadAll();
      resetCiudadForm();
      showFeedback(editingCiudadId ? "Ciudad actualizada correctamente." : "Ciudad creada correctamente.");
    } catch (error) {
      showFeedback(getErrorMessage(error, "No fue posible guardar la ciudad."), "error");
    }
  };

  const deleteUser = async (user) => {
    if (!window.confirm(`Deseas eliminar el usuario ${user.username}?`)) return;
    try {
      await axios.delete(`${API_BASE}/api/auth/users/${user.id}/`, authConfig);
      await loadAll();
      if (editingUserId === user.id) resetUserForm();
      showFeedback("Usuario eliminado correctamente.");
    } catch (error) {
      showFeedback(getErrorMessage(error, "No fue posible eliminar el usuario."), "error");
    }
  };

  const deleteEmpresa = async (empresa) => {
    if (!window.confirm(`Deseas eliminar la empresa ${empresa.TENombre || empresa.TEDescripcion || empresa.TEId}?`)) return;
    try {
      await axios.delete(`${API_BASE}/api/empresas/${empresa.TEId}/`, authConfig);
      await loadAll();
      if (editingEmpresaId === empresa.TEId) resetEmpresaForm();
      showFeedback("Empresa eliminada correctamente.");
    } catch (error) {
      showFeedback(getErrorMessage(error, "No fue posible eliminar la empresa."), "error");
    }
  };

  const deleteCiudad = async (ciudad) => {
    if (!window.confirm(`Deseas eliminar la ciudad ${ciudad.TCNombre || ciudad.TCId}?`)) return;
    try {
      await axios.delete(`${API_BASE}/api/ciudades/${ciudad.TCId}/`, authConfig);
      await loadAll();
      if (editingCiudadId === ciudad.TCId) resetCiudadForm();
      showFeedback("Ciudad eliminada correctamente.");
    } catch (error) {
      showFeedback(getErrorMessage(error, "No fue posible eliminar la ciudad."), "error");
    }
  };

  // --- Tipos de Reporte ---
  const handleSaveTipoReporte = async (e) => {
    e.preventDefault();
    try {
      if (editingTipoReporteId) {
        await axios.put(
          `${API_BASE}/api/tablas-maestras/tipo-reporte/${editingTipoReporteId}/`,
          tipoReporteForm,
          authConfig
        );
        showFeedback("Tipo de reporte actualizado", "success");
      } else {
        await axios.post(`${API_BASE}/api/tablas-maestras/tipo-reporte/`, tipoReporteForm, authConfig);
        showFeedback("Tipo de reporte creado", "success");
      }
      setTipoReporteForm(initialTipoReporteForm);
      setEditingTipoReporteId(null);
      loadAll();
    } catch (error) {
      showFeedback(getErrorMessage(error, "Error al guardar el tipo de reporte"), "error");
    }
  };

  const handleEditTipoReporte = (tr) => {
    setTipoReporteForm({
      TRHTipoReporte: tr.TRHTipoReporte,
      TRDescripcion: tr.TRDescripcion || "",
      TRPeso: tr.TRPeso || "",
      TRActivo: tr.TRActivo,
    });
    setEditingTipoReporteId(tr.TRHTipoReporte);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDeleteTipoReporte = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este tipo de reporte?")) return;
    try {
      await axios.delete(`${API_BASE}/api/tablas-maestras/tipo-reporte/${id}/`, authConfig);
      showFeedback("Tipo de reporte eliminado", "success");
      loadAll();
    } catch (error) {
      showFeedback(getErrorMessage(error, "Error al eliminar"), "error");
    }
  };

  const cancelEditTipoReporte = () => {
    setTipoReporteForm(initialTipoReporteForm);
    setEditingTipoReporteId(null);
  };

  // --- Puntajes y Colores ---
  const handleSavePuntajeColor = async (e) => {
    e.preventDefault();
    try {
      if (editingPuntajeColorId) {
        await axios.put(
          `${API_BASE}/api/tablas-maestras/puntaje-color/${editingPuntajeColorId}/`,
          puntajeColorForm,
          authConfig
        );
        showFeedback("Configuración de puntaje actualizada", "success");
      } else {
        await axios.post(`${API_BASE}/api/tablas-maestras/puntaje-color/`, puntajeColorForm, authConfig);
        showFeedback("Configuración de puntaje creada", "success");
      }
      setPuntajeColorForm(initialPuntajeColorForm);
      setEditingPuntajeColorId(null);
      loadAll();
    } catch (error) {
      showFeedback(getErrorMessage(error, "Error al guardar configuración"), "error");
    }
  };

  const handleEditPuntajeColor = (pc) => {
    setPuntajeColorForm({
      TPCNivel: pc.TPCNivel,
      TPCValorInicial: pc.TPCValorInicial,
      TPCValorFinal: pc.TPCValorFinal,
      TPCColor: pc.TPCColor || "#000000",
      TPCEvaluacion: pc.TPCEvaluacion || "",
      TPCComentario: pc.TPCComentario || "",
      TPCActivo: pc.TPCActivo,
    });
    setEditingPuntajeColorId(pc.TPCNivel);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDeletePuntajeColor = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar esta configuración de puntaje?")) return;
    try {
      await axios.delete(`${API_BASE}/api/tablas-maestras/puntaje-color/${id}/`, authConfig);
      showFeedback("Configuración eliminada", "success");
      loadAll();
    } catch (error) {
      showFeedback(getErrorMessage(error, "Error al eliminar"), "error");
    }
  };

  const cancelEditPuntajeColor = () => {
    setPuntajeColorForm(initialPuntajeColorForm);
    setEditingPuntajeColorId(null);
  };


  const inputClass = "w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[var(--app-primary)] focus:outline-none";
  return (
    <AppShell
      eyebrow="Parametrizacion"
      title="Parametrización general"
      subtitle="Usuarios, empresas y ciudades ahora usan el mismo formato de tarjetas, formularios y botones del menu principal."
    >
      {feedback && <div className={`app-message ${feedbackType === "error" ? "app-message--error" : "app-message--success"}`}>{feedback}</div>}

      <section className="app-stat-grid">
        <div 
          className="app-stat" 
          onClick={() => setActiveView("usuarios")}
          style={{ cursor: "pointer", borderColor: activeView === "usuarios" ? "var(--primary-color)" : "var(--border-color)" }}
        >
          <strong>{users.length}</strong>
          <span>Usuarios registrados</span>
        </div>
        <div 
          className="app-stat" 
          onClick={() => setActiveView("empresas")}
          style={{ cursor: "pointer", borderColor: activeView === "empresas" ? "var(--primary-color)" : "var(--border-color)" }}
        >
          <strong>{empresas.length}</strong>
          <span>Empresas disponibles</span>
        </div>
        <div 
          className="app-stat" 
          onClick={() => setActiveView("ciudades")}
          style={{ cursor: "pointer", borderColor: activeView === "ciudades" ? "var(--primary-color)" : "var(--border-color)" }}
        >
          <strong>{ciudades.length}</strong>
          <span>Ciudades disponibles</span>
        </div>
        <div 
          className="app-stat" 
          onClick={() => setActiveView("tipo-reporte")}
          style={{ cursor: "pointer", borderColor: activeView === "tipo-reporte" ? "var(--primary-color)" : "var(--border-color)" }}
        >
          <strong>{tiposReporte.length}</strong>
          <span>Tipos de Reporte</span>
        </div>
        <div 
          className="app-stat" 
          onClick={() => setActiveView("puntaje-color")}
          style={{ cursor: "pointer", borderColor: activeView === "puntaje-color" ? "var(--primary-color)" : "var(--border-color)" }}
        >
          <strong>{puntajesColor.length}</strong>
          <span>Niveles de Puntaje</span>
        </div>
        <div 
          className="app-stat" 
          onClick={() => setActiveView("ipc")}
          style={{ cursor: "pointer", borderColor: activeView === "ipc" ? "var(--primary-color)" : "var(--border-color)" }}
        >
          <strong>{ipcs.length}</strong>
          <span>Incremento IPC</span>
        </div>
      </section>

      {(() => {
        const filteredUsers = users.filter((u) => (u.username || "").toLowerCase().includes(searchUsuario.toLowerCase()));
        const filteredEmpresas = empresas.filter((e) => (e.TENombre || "").toLowerCase().includes(searchEmpresa.toLowerCase()));
        const filteredCiudades = ciudades.filter((c) => (c.TCNombre || "").toLowerCase().includes(searchCiudad.toLowerCase()));

        // --- Tipos de Reporte ---
  const handleSaveTipoReporte = async (e) => {
    e.preventDefault();
    try {
      if (editingTipoReporteId) {
        await axios.put(
          `${API_BASE}/api/tablas-maestras/tipo-reporte/${editingTipoReporteId}/`,
          tipoReporteForm,
          authConfig
        );
        showFeedback("Tipo de reporte actualizado", "success");
      } else {
        await axios.post(`${API_BASE}/api/tablas-maestras/tipo-reporte/`, tipoReporteForm, authConfig);
        showFeedback("Tipo de reporte creado", "success");
      }
      setTipoReporteForm(initialTipoReporteForm);
      setEditingTipoReporteId(null);
      loadAll();
    } catch (error) {
      showFeedback(getErrorMessage(error, "Error al guardar el tipo de reporte"), "error");
    }
  };

  const handleEditTipoReporte = (tr) => {
    setTipoReporteForm({
      TRHTipoReporte: tr.TRHTipoReporte,
      TRDescripcion: tr.TRDescripcion || "",
      TRPeso: tr.TRPeso || "",
      TRActivo: tr.TRActivo,
    });
    setEditingTipoReporteId(tr.TRHTipoReporte);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDeleteTipoReporte = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este tipo de reporte?")) return;
    try {
      await axios.delete(`${API_BASE}/api/tablas-maestras/tipo-reporte/${id}/`, authConfig);
      showFeedback("Tipo de reporte eliminado", "success");
      loadAll();
    } catch (error) {
      showFeedback(getErrorMessage(error, "Error al eliminar"), "error");
    }
  };

  const cancelEditTipoReporte = () => {
    setTipoReporteForm(initialTipoReporteForm);
    setEditingTipoReporteId(null);
  };

  // --- Puntajes y Colores ---
  const handleSavePuntajeColor = async (e) => {
    e.preventDefault();
    try {
      if (editingPuntajeColorId) {
        await axios.put(
          `${API_BASE}/api/tablas-maestras/puntaje-color/${editingPuntajeColorId}/`,
          puntajeColorForm,
          authConfig
        );
        showFeedback("Configuración de puntaje actualizada", "success");
      } else {
        await axios.post(`${API_BASE}/api/tablas-maestras/puntaje-color/`, puntajeColorForm, authConfig);
        showFeedback("Configuración de puntaje creada", "success");
      }
      setPuntajeColorForm(initialPuntajeColorForm);
      setEditingPuntajeColorId(null);
      loadAll();
    } catch (error) {
      showFeedback(getErrorMessage(error, "Error al guardar configuración"), "error");
    }
  };

  const handleEditPuntajeColor = (pc) => {
    setPuntajeColorForm({
      TPCNivel: pc.TPCNivel,
      TPCValorInicial: pc.TPCValorInicial,
      TPCValorFinal: pc.TPCValorFinal,
      TPCColor: pc.TPCColor || "#000000",
      TPCEvaluacion: pc.TPCEvaluacion || "",
      TPCComentario: pc.TPCComentario || "",
      TPCActivo: pc.TPCActivo,
    });
    setEditingPuntajeColorId(pc.TPCNivel);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDeletePuntajeColor = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar esta configuración de puntaje?")) return;
    try {
      await axios.delete(`${API_BASE}/api/tablas-maestras/puntaje-color/${id}/`, authConfig);
      showFeedback("Configuración eliminada", "success");
      loadAll();
    } catch (error) {
      showFeedback(getErrorMessage(error, "Error al eliminar"), "error");
    }
  };

  const cancelEditPuntajeColor = () => {
    setPuntajeColorForm(initialPuntajeColorForm);
    setEditingPuntajeColorId(null);
  };

  // --- IPC Anual ---
  const handleSaveIpc = async (e) => {
    e.preventDefault();
    try {
      if (editingIpcAnio) {
        await axios.put(
          `${API_BASE}/api/tablas-maestras/ipc/${editingIpcAnio}/`,
          ipcForm,
          authConfig
        );
        showFeedback("Parámetro IPC actualizado correctamente.", "success");
      } else {
        await axios.post(`${API_BASE}/api/tablas-maestras/ipc/`, ipcForm, authConfig);
        showFeedback("Parámetro IPC creado correctamente.", "success");
      }
      setIpcForm(initialIpcForm);
      setEditingIpcAnio(null);
      loadAll();
    } catch (error) {
      showFeedback(getErrorMessage(error, "Error al guardar parámetro IPC."), "error");
    }
  };

  const handleEditIpc = (item) => {
    setIpcForm({
      anio: item.anio,
      porcentaje: item.porcentaje,
      descripcion: item.descripcion || "",
      activo: item.activo,
    });
    setEditingIpcAnio(item.anio);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDeleteIpc = async (anio) => {
    if (!window.confirm(`¿Estás seguro de eliminar el parámetro IPC para el año ${anio}?`)) return;
    try {
      await axios.delete(`${API_BASE}/api/tablas-maestras/ipc/${anio}/`, authConfig);
      showFeedback("Parámetro IPC eliminado", "success");
      loadAll();
    } catch (error) {
      showFeedback(getErrorMessage(error, "Error al eliminar parámetro IPC"), "error");
    }
  };

  const cancelEditIpc = () => {
    setIpcForm(initialIpcForm);
    setEditingIpcAnio(null);
  };

  const filteredIpcs = ipcs.filter((item) => {
    const term = searchIpc.toLowerCase();
    return (
      item.anio?.toString().includes(term) ||
      item.descripcion?.toLowerCase().includes(term) ||
      item.porcentaje?.toString().includes(term)
    );
  });


  const inputClass = "w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[var(--app-primary)] focus:outline-none";
  return (
          <>
            {loading ? (
              <div className="app-message app-message--info">Cargando informacion administrativa...</div>
            ) : (
              <>
                {activeView === "usuarios" && (
                  <section className="app-surface">
                    <div className="app-section-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                      <h2 style={{ margin: 0 }}>Gestion de usuarios</h2>
                      <input 
                        type="text" 
                        placeholder="Buscar por Usuario..." 
                        value={searchUsuario} 
                        onChange={(e) => setSearchUsuario(e.target.value)} 
                        className="app-input" 
                        style={{ maxWidth: '300px', margin: 0 }} 
                      />
                    </div>
            <form className="app-form-grid" onSubmit={submitUser} autoComplete="off">
              <input autoComplete="off" type="text" placeholder="Usuario" value={userForm.username} onChange={(e) => setUserForm({ ...userForm, username: e.target.value })} required />
              <input autoComplete="off" type="email" placeholder="Correo" value={userForm.email} onChange={(e) => setUserForm({ ...userForm, email: e.target.value })} required />
              <input autoComplete="off" type="text" placeholder="Nombres" value={userForm.first_name} onChange={(e) => setUserForm({ ...userForm, first_name: e.target.value })} />
              <input autoComplete="off" type="text" placeholder="Apellidos" value={userForm.last_name} onChange={(e) => setUserForm({ ...userForm, last_name: e.target.value })} />
              <input autoComplete="new-password" type="password" placeholder={editingUserId ? "Nueva contrasena opcional" : "Contrasena"} value={userForm.password} onChange={(e) => setUserForm({ ...userForm, password: e.target.value })} />
              <select value={userForm.role} onChange={(e) => setUserForm({ ...userForm, role: e.target.value })}>
                <option value="ADMINISTRADOR">Usuario Administrador</option>
                <option value="ARRENDADOR">Usuario Arrendador</option>
                <option value="ARRENDATARIO">Usuario Arrendatario</option>
              </select>
              <div className="app-actions">
                <button className="app-button app-button--secondary" type="button" onClick={resetUserForm}>Limpiar</button>
                <button className="app-button app-button--primary" type="submit">{editingUserId ? "Guardar cambios" : "Agregar usuario"}</button>
              </div>
            </form>

            <div className="app-table-wrap">
              <table className="app-table">
                <thead>
                  <tr>
                    <th>Usuario</th>
                    <th>Correo</th>
                    <th>Rol</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers.map((user) => (
                    <tr key={user.id}>
                      <td>{user.username}</td>
                      <td>{user.email}</td>
                      <td>{user.role_label || user.role_value}</td>
                      <td>
                        <div className="app-inline-actions">
                          <button className="app-table-button" type="button" onClick={() => {
                            setEditingUserId(user.id);
                            setUserForm({
                              username: user.username || "",
                              email: user.email || "",
                              first_name: user.first_name || "",
                              last_name: user.last_name || "",
                              password: "",
                              role: user.role_value || "ARRENDADOR",
                            });
                          }}>Editar</button>
                          <button className="app-table-button app-table-button--danger" type="button" disabled={user.username === currentUsername} onClick={() => deleteUser(user)}>Eliminar</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
          )}

          {activeView === "empresas" && (
          <section className="app-surface">
            <div className="app-section-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
              <h2 style={{ margin: 0 }}>Gestion de empresas</h2>
              <input 
                type="text" 
                placeholder="Buscar por Nombre..." 
                value={searchEmpresa} 
                onChange={(e) => setSearchEmpresa(e.target.value)} 
                className="app-input" 
                style={{ maxWidth: '300px', margin: 0 }} 
              />
            </div>
            <form className="app-form-grid" onSubmit={submitEmpresa} autoComplete="off">
              <input autoComplete="off" type="text" placeholder="NIT" value={empresaForm.TENit} onChange={(e) => setEmpresaForm({ ...empresaForm, TENit: e.target.value })} />
              <input autoComplete="off" type="text" placeholder="Nombre" value={empresaForm.TENombre} onChange={(e) => setEmpresaForm({ ...empresaForm, TENombre: e.target.value })} />
              <div style={{ gridColumn: "1 / -1" }}>
                <ColombianAddressInput
                  value={empresaForm.TEDireccion}
                  onChange={(e) => setEmpresaForm({ ...empresaForm, TEDireccion: e.target.value })}
                  onValidationChange={setIsEmpresaAddressValid}
                  name="TEDireccion"
                  placeholder="Dirección Empresa"
                  required={false}
                />
              </div>
              <select value={empresaForm.TECiudad} onChange={(e) => setEmpresaForm({ ...empresaForm, TECiudad: e.target.value })}>
                <option value="">Seleccione una ciudad (opcional)</option>
                {ciudades.map(c => <option key={c.TCId} value={c.TCId}>{c.TCNombre} {c.TCDepartamento ? `- ${c.TCDepartamento}` : ''}</option>)}
              </select>
              <input autoComplete="off" type="text" placeholder="Celular" value={empresaForm.TECelular} onChange={(e) => setEmpresaForm({ ...empresaForm, TECelular: e.target.value })} />
              <input autoComplete="off" type="text" placeholder="Telefono" value={empresaForm.TETelefono} onChange={(e) => setEmpresaForm({ ...empresaForm, TETelefono: e.target.value })} />
              <input autoComplete="off" type="email" placeholder="Correo" value={empresaForm.TEEmail} onChange={(e) => setEmpresaForm({ ...empresaForm, TEEmail: e.target.value })} />
              <input autoComplete="off" type="text" placeholder="Contacto" value={empresaForm.TEContacto} onChange={(e) => setEmpresaForm({ ...empresaForm, TEContacto: e.target.value })} />
              <input autoComplete="off" type="text" placeholder="Descripcion" value={empresaForm.TEDescripcion} onChange={(e) => setEmpresaForm({ ...empresaForm, TEDescripcion: e.target.value })} />
              <div className="app-actions">
                <button className="app-button app-button--secondary" type="button" onClick={resetEmpresaForm}>Limpiar</button>
                <button className="app-button app-button--primary" type="submit">{editingEmpresaId ? "Guardar empresa" : "Agregar empresa"}</button>
              </div>
            </form>

            <div className="app-table-wrap">
              <table className="app-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Descripcion</th>
                    <th>Ciudad</th>
                    <th>Contacto</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredEmpresas.map((empresa) => (
                    <tr key={empresa.TEId}>
                      <td>{empresa.TENombre || "-"}</td>
                      <td>{empresa.TEDescripcion || "-"}</td>
                      <td>{empresa.TECiudad ? (ciudades.find(c => c.TCId === empresa.TECiudad)?.TCNombre || empresa.TECiudad) : "-"}</td>
                      <td>{empresa.TEContacto || empresa.TEEmail || "-"}</td>
                      <td>
                        <div className="app-inline-actions">
                          <button className="app-table-button" type="button" onClick={() => {
                            setEditingEmpresaId(empresa.TEId);
                            setEmpresaForm({
                              TENit: empresa.TENit || "",
                              TENombre: empresa.TENombre || "",
                              TEDireccion: empresa.TEDireccion || "",
                              TECiudad: empresa.TECiudad || "",
                              TECelular: empresa.TECelular || "",
                              TETelefono: empresa.TETelefono || "",
                              TEEmail: empresa.TEEmail || "",
                              TEContacto: empresa.TEContacto || "",
                              TEDescripcion: empresa.TEDescripcion || "",
                            });
                          }}>Editar</button>
                          <button className="app-table-button app-table-button--danger" type="button" onClick={() => deleteEmpresa(empresa)}>Eliminar</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
          )}

          {activeView === "ciudades" && (
          <section className="app-surface">
            <div className="app-section-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
              <h2 style={{ margin: 0 }}>Gestion de ciudades</h2>
              <input 
                type="text" 
                placeholder="Buscar por Nombre..." 
                value={searchCiudad} 
                onChange={(e) => setSearchCiudad(e.target.value)} 
                className="app-input" 
                style={{ maxWidth: '300px', margin: 0 }} 
              />
            </div>
            <form className="app-form-grid" onSubmit={submitCiudad} autoComplete="off">
              <input autoComplete="off" type="text" placeholder="Nombre" value={ciudadForm.TCNombre} onChange={(e) => setCiudadForm({ ...ciudadForm, TCNombre: e.target.value })} />
              <input autoComplete="off" type="text" placeholder="Departamento" value={ciudadForm.TCDepartamento} onChange={(e) => setCiudadForm({ ...ciudadForm, TCDepartamento: e.target.value })} />
              <input autoComplete="off" type="text" placeholder="Pais" value={ciudadForm.TCPais} onChange={(e) => setCiudadForm({ ...ciudadForm, TCPais: e.target.value })} />
              <div className="app-actions">
                <button className="app-button app-button--secondary" type="button" onClick={resetCiudadForm}>Limpiar</button>
                <button className="app-button app-button--primary" type="submit">{editingCiudadId ? "Guardar ciudad" : "Agregar ciudad"}</button>
              </div>
            </form>

            <div className="app-table-wrap">
              <table className="app-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Departamento</th>
                    <th>Pais</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCiudades.map((ciudad) => (
                    <tr key={ciudad.TCId}>
                      <td>{ciudad.TCNombre || "-"}</td>
                      <td>{ciudad.TCDepartamento || "-"}</td>
                      <td>{ciudad.TCPais || "-"}</td>
                      <td>
                        <div className="app-inline-actions">
                          <button className="app-table-button" type="button" onClick={() => {
                            setEditingCiudadId(ciudad.TCId);
                            setCiudadForm({
                              TCNombre: ciudad.TCNombre || "",
                              TCDepartamento: ciudad.TCDepartamento || "",
                              TCPais: ciudad.TCPais || "",
                            });
                          }}>Editar</button>
                          <button className="app-table-button app-table-button--danger" type="button" onClick={() => deleteCiudad(ciudad)}>Eliminar</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
          )}

          {activeView === "tipo-reporte" && (
          <section className="app-surface">
            <div className="app-section-title">
              <h2 style={{ margin: 0 }}>Tipos de Reporte</h2>
            </div>
            <form className="app-form-grid" onSubmit={handleSaveTipoReporte} autoComplete="off">
              <input autoComplete="off" type="text" placeholder="Código (ej: DA)" value={tipoReporteForm.TRHTipoReporte} onChange={(e) => setTipoReporteForm({ ...tipoReporteForm, TRHTipoReporte: e.target.value })} disabled={!!editingTipoReporteId} required />
              <input autoComplete="off" type="text" placeholder="Descripción" value={tipoReporteForm.TRDescripcion} onChange={(e) => setTipoReporteForm({ ...tipoReporteForm, TRDescripcion: e.target.value })} required />
              <input autoComplete="off" type="number" placeholder="Peso (ej: 50)" value={tipoReporteForm.TRPeso} onChange={(e) => setTipoReporteForm({ ...tipoReporteForm, TRPeso: e.target.value })} required />
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input type="checkbox" id="trActivo" checked={tipoReporteForm.TRActivo} onChange={(e) => setTipoReporteForm({ ...tipoReporteForm, TRActivo: e.target.checked })} />
                <label htmlFor="trActivo">Activo</label>
              </div>
              <div className="app-actions">
                <button className="app-button app-button--secondary" type="button" onClick={cancelEditTipoReporte}>Limpiar</button>
                <button className="app-button app-button--primary" type="submit">{editingTipoReporteId ? "Guardar cambios" : "Agregar tipo"}</button>
              </div>
            </form>

            <div className="app-table-wrap">
              <table className="app-table">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Descripción</th>
                    <th>Peso</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {tiposReporte.map((tr) => (
                    <tr key={tr.TRHTipoReporte}>
                      <td>{tr.TRHTipoReporte}</td>
                      <td>{tr.TRDescripcion}</td>
                      <td>{tr.TRPeso}</td>
                      <td>{tr.TRActivo ? "Activo" : "Inactivo"}</td>
                      <td>
                        <div className="app-inline-actions">
                          <button className="app-table-button" type="button" onClick={() => handleEditTipoReporte(tr)}>Editar</button>
                          <button className="app-table-button app-table-button--danger" type="button" onClick={() => handleDeleteTipoReporte(tr.TRHTipoReporte)}>Eliminar</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
          )}

          {activeView === "puntaje-color" && (
          <section className="app-surface">
            <div className="app-section-title">
              <h2 style={{ margin: 0 }}>Niveles de Puntaje</h2>
            </div>
            <form className="app-form-grid" onSubmit={handleSavePuntajeColor} autoComplete="off">
              <input autoComplete="off" type="text" placeholder="Nivel (ej: EXCELENTE)" value={puntajeColorForm.TPCNivel} onChange={(e) => setPuntajeColorForm({ ...puntajeColorForm, TPCNivel: e.target.value })} disabled={!!editingPuntajeColorId} required />
              <input autoComplete="off" type="number" placeholder="Valor Inicial" value={puntajeColorForm.TPCValorInicial} onChange={(e) => setPuntajeColorForm({ ...puntajeColorForm, TPCValorInicial: e.target.value })} required />
              <input autoComplete="off" type="number" placeholder="Valor Final" value={puntajeColorForm.TPCValorFinal} onChange={(e) => setPuntajeColorForm({ ...puntajeColorForm, TPCValorFinal: e.target.value })} required />
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input type="color" value={puntajeColorForm.TPCColor} onChange={(e) => setPuntajeColorForm({ ...puntajeColorForm, TPCColor: e.target.value })} style={{ width: '40px', height: '40px', padding: '0', border: 'none' }} />
                <span>Color Hex</span>
              </div>
              <input autoComplete="off" type="text" placeholder="Evaluación (ej: Buen arrendatario)" value={puntajeColorForm.TPCEvaluacion} onChange={(e) => setPuntajeColorForm({ ...puntajeColorForm, TPCEvaluacion: e.target.value })} />
              <input autoComplete="off" type="text" placeholder="Comentario detallado" value={puntajeColorForm.TPCComentario} onChange={(e) => setPuntajeColorForm({ ...puntajeColorForm, TPCComentario: e.target.value })} style={{ gridColumn: '1 / -1' }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input type="checkbox" id="tpcActivo" checked={puntajeColorForm.TPCActivo} onChange={(e) => setPuntajeColorForm({ ...puntajeColorForm, TPCActivo: e.target.checked })} />
                <label htmlFor="tpcActivo">Activo</label>
              </div>
              <div className="app-actions">
                <button className="app-button app-button--secondary" type="button" onClick={cancelEditPuntajeColor}>Limpiar</button>
                <button className="app-button app-button--primary" type="submit">{editingPuntajeColorId ? "Guardar cambios" : "Agregar nivel"}</button>
              </div>
            </form>

            <div className="app-table-wrap">
              <table className="app-table">
                <thead>
                  <tr>
                    <th>Nivel</th>
                    <th>Rango</th>
                    <th>Color</th>
                    <th>Evaluación</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {puntajesColor.map((pc) => (
                    <tr key={pc.TPCNivel}>
                      <td>{pc.TPCNivel}</td>
                      <td>{pc.TPCValorInicial} - {pc.TPCValorFinal}</td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div style={{ width: '20px', height: '20px', backgroundColor: pc.TPCColor, borderRadius: '4px' }}></div>
                          {pc.TPCColor}
                        </div>
                      </td>
                      <td>{pc.TPCEvaluacion}</td>
                      <td>
                        <div className="app-inline-actions">
                          <button className="app-table-button" type="button" onClick={() => handleEditPuntajeColor(pc)}>Editar</button>
                          <button className="app-table-button app-table-button--danger" type="button" onClick={() => handleDeletePuntajeColor(pc.TPCNivel)}>Eliminar</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
          )}

          {activeView === "ipc" && (
          <section className="app-surface">
            <div className="app-section-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
              <div>
                <h2 style={{ margin: 0 }}>Incremento del IPC por Año</h2>
                <p style={{ margin: '4px 0 0', color: 'var(--app-text-muted)', fontSize: '0.9rem' }}>
                  Porcentajes aplicados automáticamente al valor del canon de arrendamiento al cumplir cada año de contrato.
                </p>
              </div>
              <input 
                type="text" 
                placeholder="Buscar por Año o Descripción..." 
                value={searchIpc} 
                onChange={(e) => setSearchIpc(e.target.value)} 
                className="app-input" 
                style={{ maxWidth: '300px', margin: 0 }} 
              />
            </div>
            <form className="app-form-grid" onSubmit={handleSaveIpc} autoComplete="off">
              <div className="app-field">
                <label>Año (ej: 2026)</label>
                <input 
                  autoComplete="off" 
                  type="number" 
                  placeholder="Año (ej: 2026)" 
                  value={ipcForm.anio} 
                  onChange={(e) => setIpcForm({ ...ipcForm, anio: e.target.value })} 
                  disabled={!!editingIpcAnio} 
                  required 
                  className="app-input"
                />
              </div>

              <div className="app-field">
                <label>Porcentaje IPC (%)</label>
                <input 
                  autoComplete="off" 
                  type="number" 
                  step="0.01" 
                  placeholder="Porcentaje IPC (ej: 5.50)" 
                  value={ipcForm.porcentaje} 
                  onChange={(e) => setIpcForm({ ...ipcForm, porcentaje: e.target.value })} 
                  required 
                  className="app-input"
                />
              </div>

              <div className="app-field" style={{ gridColumn: 'span 2' }}>
                <label>Descripción / Norma</label>
                <input 
                  autoComplete="off" 
                  type="text" 
                  placeholder="Descripción (ej: IPC DANE 2026 / Ley 820)" 
                  value={ipcForm.descripcion} 
                  onChange={(e) => setIpcForm({ ...ipcForm, descripcion: e.target.value })} 
                  className="app-input"
                />
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '24px' }}>
                <input 
                  type="checkbox" 
                  id="ipcActivo" 
                  checked={ipcForm.activo} 
                  onChange={(e) => setIpcForm({ ...ipcForm, activo: e.target.checked })} 
                />
                <label htmlFor="ipcActivo">Activo para cálculo</label>
              </div>

              <div className="app-actions" style={{ gridColumn: '1 / -1' }}>
                <button className="app-button app-button--secondary" type="button" onClick={cancelEditIpc}>
                  {editingIpcAnio ? "Cancelar" : "Limpiar"}
                </button>
                <button className="app-button app-button--primary" type="submit">
                  {editingIpcAnio ? "Guardar cambios" : "Agregar porcentaje IPC"}
                </button>
              </div>
            </form>

            <div className="app-table-wrap">
              <table className="app-table">
                <thead>
                  <tr>
                    <th>Año</th>
                    <th>Porcentaje IPC</th>
                    <th>Descripción</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredIpcs.length === 0 ? (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center', padding: '24px' }}>
                        No se encontraron registros de IPC.
                      </td>
                    </tr>
                  ) : (
                    filteredIpcs.map((item) => (
                      <tr key={item.anio}>
                        <td><strong>{item.anio}</strong></td>
                        <td>
                          <span style={{ fontWeight: '700', color: '#0284c7' }}>
                            {item.porcentaje}%
                          </span>
                        </td>
                        <td>{item.descripcion || "—"}</td>
                        <td>
                          {item.activo ? (
                            <span style={{ color: '#16a34a', fontWeight: '600' }}>Activo</span>
                          ) : (
                            <span style={{ color: '#dc2626', fontWeight: '600' }}>Inactivo</span>
                          )}
                        </td>
                        <td>
                          <div className="app-inline-actions">
                            <button className="app-table-button" type="button" onClick={() => handleEditIpc(item)}>Editar</button>
                            <button className="app-table-button app-table-button--danger" type="button" onClick={() => handleDeleteIpc(item.anio)}>Eliminar</button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </section>
          )}

        </>
      )}
      </>
      );
      })()}
    </AppShell>
  );
}


